"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveCustomerOrderEvent = exports.Name = void 0;
const Name = exports.Name = 'remove-customer-order';
const RemoveCustomerOrderEvent = exports.RemoveCustomerOrderEvent = Name;
//# sourceMappingURL=index.js.map